$(function(){
  
  /* ==================================== 초기UI 실행 호출함수 호출  ==================================== */
  window.pubUI = new PubUI();
  window.pubUI.gnb_footer();    // 높이 설정
  ///window.pubUI.base();       // 기본실행
  window.pubUI.forms();         // 폼요소
  window.pubUI.hartMotion();    // 하트 모션
  window.pubUI.scrollTop();     // 스크롤탑
  window.pubUI.mobileBack();    // 모바일 뒤로가기
  window.pubUI.append_script(); // 스크립트 애드
  

  /* 리싸이즈 공통 */
  $(window).on("resize", function(){
    responsiveDevices();        // width  : pc, mobile 체크    
    window.pubUI.gnb_footer();
  });
  responsiveDevices();
  window.pubUI.gnb_footer();

});

/* ==================================== 초기UI 실행 함수 호출  ==================================== */
function PubUI() {
  var _this = this;

  /* 해더 높이 자동 */
  _this.gnb_footer = function() {
    var _topH = $("header.header").innerHeight();
    var _footerH = $("footer.footer").innerHeight();
    gnb_footer_resize(_topH, _footerH);
  }

  _this.base = function() {
    var vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
    window.addEventListener('resize', () => {
      var vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    })
  }

  _this.forms = function() {
    
    /* input del */
    function inputdel_fn($this) {
      ///console.log('$this.val()', $this.val());
      var _noneDisable = !$this.prop("disabled");
      if( $this.val() != "" && _noneDisable){
          $this.siblings("button").css({display:"block"});
          $this.siblings("button").one("click", function(){
              $this.val("");
              $this.siblings("button").css({display:"none"});
          });
      }else{
          $this.siblings("button").css({display:"none"});
      }
    }
    $("body").on("focusout", ".input_del input", function(){
        inputdel_fn( $(this) );
    });
    $("body .input_del input").each(function($i){
        inputdel_fn( $(this) );
    });

    /* select - box */
    $(".select2Basic").select2({            
      minimumResultsForSearch: Infinity,
      /*theme: "basic"*/
    });
    $(".select2Basic42").select2({            
      minimumResultsForSearch: Infinity,
      /*theme: "basic"*/
    });
    $(".select2Basic50").select2({            
      minimumResultsForSearch: Infinity,
      /*theme: "basic"*/
    });
    $(".select2Basic_aa").select2({            
      minimumResultsForSearch: Infinity,
      dropdownCssClass : 'select_none_line',
      /*theme: "basic"*/
    });

    $(".select2Basic56_line").select2({            
      minimumResultsForSearch: Infinity,
      /*theme: "basic"*/
    });

  }

  _this.hartMotion = function() {    
    https://www.npmjs.com/package/mo-js
    /* var _hartMotion = new mojs.Burst({ left: 0, top: 0, count: 6,
      className : "mojs_hart",
			radius:   { 5: 20 },
			children: { 
				easing: 'cubic.out',
				fill:   "#4DADA7"  ,
    		duration: 500,
			}
		});  */
		$('.js-work_heart').on('click', function($e) {
			$e.preventDefault();
			$(this).toggleClass('on');
			///if( $(this).hasClass("on") )
      //console.log( $e.pageX , " :: ", $(this).offset().top );
			//_hartMotion.tune({ x: $e.pageX, y: $e.pageY }).generate().replay();
		})
  }

  _this.scrollTop = function() {    
    $(".js-scroll_top").on("click", function($e){
      $e.preventDefault();
      var _position = 0 ///$(selector).offset();
      $('html, body' ).animate( { scrollTop: _position }, 370 );
    })
  }

  _this.mobileBack = function() {    
    $(".js-history_back").click(function(){
			window.history.back();
		})
  }


  /* 탑버튼 보이기 */
  $(window).scroll(function(){
    if($(window).scrollTop() > 400){
			$(".js-scroll_top").addClass("show");
		}else{
			$(".js-scroll_top").removeClass("show");
		}
  })

  
  /* 탑버튼 높이 변경 */
  $(window).resize(function(){
    if($(".proceeding-article").length > 0 && $(window).width() < 1024){
      $(".js-scroll_top").css("transform","translateY(-70px)")
    }else{
      $(".js-scroll_top").css("transform","")
    }
  })

  


  /* 초기실행 스크립트 */
  _this.append_script = function() {
    ///$("body").append( $(".js-append-script") );
  }

  
}

/* ==================================== 초기실행 함수 호출  ==================================== */
var _szTB  = 1439;   //
var _szMB  = 1023;   //
var _szMS  = 760;    //
/* 호출 */
function responsiveDevices(){ 
    var _change_width = window.innerWidth; //  $(window).innerWidth(); //
    var _temp_width;  
    //console.log(_change_width)
    if( _change_width > _szTB){
       _temp_width = "is_pc";
    }else if(_change_width > _szMB){
       _temp_width = "is_pc";
    }else {
      _temp_width = "is_mb";
    };
    if (!$('body').hasClass(_temp_width)) {
      $("body").removeClass("is_pc is_tb is_mb is_ms");
      $("body").addClass(_temp_width);
      $("body").attr( "data-device" , _temp_width);
      console.log("===============responsiveDevices=====================")
    }
    return _temp_width
}


/* PC,MB images resize */
function imagesResizePcMb(){
  var _tar = $(".imageViewer"); ///document.querySelector(".imageViewer");
  ///console.log("googooowwww: " , _tar[0].naturalWidth, _tar.length);

  for(var i = 0 ; i < _tar.length ; i++){

    if(!_tar[i]){ return false;}
    /*  
     [2022-0707]원복 /[2022-0701] 고객사요청  */
     var _orgW = _tar[i].naturalWidth;
     var _orgH = _tar[i].naturalHeight; 
     if($("body").hasClass("is_mb")){
         _tar[i].width  = _orgW * .55;
         _tar[i].height = _orgH * .55;
       }else{
         _tar[i].width  = _orgW;
         _tar[i].height = _orgH;
       } 
    
     /* var z = ((parseFloat($(window).width() / 1024) >= 1)?1:parseFloat($(window).width() / 1024));    
     var w = (parseFloat(parseInt($(_tar[i]).attr("size2"))) / 250) * 500 * z;
     _tar[i].width = w; */
     /* // [2022-0701] 고객사요청 */

  }

  /// console.log("=========imgresize=========", _orgW, _orgH, $("body").hasClass("is_mb"))
}


/* 팝업높이계산 */
function popup_fixation($this){  
  var _this = $this;
  var conH = $(".pop-body>.section", _this).outerHeight() + (96 + 70);  //( 해더 96, 마진 70 )
  var winH = $(window).height();

  function resizeFn(){
    winH = $(window).height();

    /* 모바일일때 && mode-mb_full 경우 사용안함 */
    if( $("body").hasClass("is_mb") && $(".popup-align",  _this).hasClass("mode-mb_full") ){
      $(".popup-align",  _this).removeClass("footer_fixed");
      return false;
    }

    /* 컨텐높이가 클때 */
    //console.log(">>> : : ", conH , winH)
    if( conH >= winH ){
      $(".popup-align", _this).addClass("footer_fixed");
    }else{
      $(".popup-align",  _this).removeClass("footer_fixed");
    }
  }
  
  $(window).on("resize", function(){
    resizeFn();
  });
  resizeFn();

}

/* 모바일 모션 팝업 */
function popup_motion_open($this){
  if($("body").hasClass("is_mb")){
    $( ".pop-panel", $this ).css({ bottom: "-110vh" });
    $( ".pop-panel", $this ).animate({ bottom: 0 }, 370)
  }
}
function popup_motion_close($this){
  if($("body").hasClass("is_mb")){					
    $( ".pop-panel", $this ).animate({ bottom: "-110vh" }, 370)
  }
}


/* 윈도우 팝업 닫기 
onclick="window.open('biddingOffline_ko-pc4.html', '','_blank');" 
onclick="javascript:window_close();"
*/



/* ========== 바디 높이 조절 ========== */
function gnb_footer_resize($h, $f){
  /*  $('.main-contents') */
  var _h = $("header.header").innerHeight();
  var _f = $("footer.footer").innerHeight();
  if($h){
    $("#contents").css({ "padding-top" : $h ,"padding-bottom" : $f });
    $("footer.footer").css({ "margin-top" : -($f)  });
  }else{
    $("#contents").css({ "padding-top" : _h, "padding-bottom" : _f});
    $("footer.footer").css({ "margin-top" : -(_f)  });
  }
}



function trpScrollTop($selector, $add_gap){
  var _position = $($selector).offset().top - ($("header.header").innerHeight() + $add_gap);
  $( 'html, body' ).animate( { scrollTop: _position }, 300 );
};